<template>
  <VideoPartial v-if="config?.video != undefined && config?.video != false && config?.video != null" :config="config"
    @close="closeVideo()" />
</template>

<script>
import VideoPartial from "@/partials/Video/Video.vue";

export default {
  name: "Videos",
  components: {
    VideoPartial,
  },
  props: {
    config: {
      type: Object,
    },
  },

  // Watch sur this.config.webcam
  watch: {
    config: {
      handler: async function (val, oldVal) {
        if (
          val.webcam != false &&
          val?.webcam != undefined &&
          this?.config?.webcam != undefined &&
          this.config?.webcam?.alreadyLoaded != true
        ) {
          this.config.webcam.alreadyLoaded = true;
        }
      },
      deep: true,
    },
  },
};
</script>
